<section class="section-container">
  <div class="section-content">
    <div class="welcome">
      <h1>Bem-vindo {{username}}!</h1>
      <p>Escolha o serviço que você precisa e clique para acessar.</p>
    </div>

    <div *ngIf="!mostrarConteudo.carne && !mostrarConteudo.cartao && !loadingCartao" class="no-content">
      <h2>Contrato de carnê e acordo de renegociação de cartão não encontrados.</h2>
      <p>Aproveite as ofertas e compre com carnê ou solicite seu cartão, caso ainda não tenha um.</p>
      <div class="actions">
        <button type="button" (click)="enviarLogAcaoCliente(LogAcaoCliente.COMPRA_CARNE)" mat-flat-button color="primary">
          Comprar com Carnê Digital
        </button>
        <button (click)="enviarLogAcaoCliente(LogAcaoCliente.CENTRAL_ATENDIMENTO)" mat-stroked-button class="outlined"
          color="primary">
          <mat-icon class="material-symbols-outlined">headset_mic</mat-icon>
          Central de atendimento
        </button>
        <button type="button" (click)="enviarLogAcaoCliente(LogAcaoCliente.CARTAO_CASAS_BAHIA)" mat-stroked-button class="outlined" color="primary">
          <img src="assets/images/icons/ic-cb-credit-card.svg" alt="cartão de credito" />
          Solicitar cartão Casas Bahia
        </button>
      </div>
    </div>

    <div *ngIf="mostrarConteudo.carne && !mostrarConteudo.cartao && !loadingCartao; else selecionarServico" class="no-content">
      <h2>Não há acordo de renegociação cadastrados para seu cartão.</h2>
      <p>Solicite já o seu cartão Casas Bahia para aproveitar mais benefícios.</p>
      <div class="actions">
        <button type="button" (click)="enviarLogAcaoCliente(LogAcaoCliente.CARTAO_CASAS_BAHIA)" mat-stroked-button class="outlined" color="primary">
          <img src="assets/images/icons/ic-cb-credit-card.svg" alt="cartão de credito" />
          Solicitar cartão Casas Bahia
        </button>
        <button (click)="enviarLogAcaoCliente(LogAcaoCliente.CENTRAL_ATENDIMENTO)" mat-stroked-button class="outlined" color="primary">
          <mat-icon class="material-symbols-outlined">headset_mic</mat-icon>
          Central de atendimento
        </button>
        <button type="button" (click)="voltarAosMeusServicos()" mat-stroked-button class="outlined link-btn" color="primary">
          <mat-icon class="material-symbols-outlined">arrow_back</mat-icon>
          Voltar aos meus serviços
        </button>
      </div>
    </div>

    <ng-template #selecionarServico>
      <ul *ngIf="mostrarConteudo.carne || mostrarConteudo.cartao" class="menu">
        <li *ngFor="let menuItem of menuItens">
          <div *ngIf="menuItem.type === 'carne' || menuItem.type === 'cartao' || loadingCartao === false; else loadingTemplate">
            <div>
            <h3>{{menuItem.title}}</h3>
            <img [src]="menuItem.icon" alt="Serviços do carnê">
            </div>
            <button type="button" (click)="gotToMenuPath(menuItem)" mat-flat-button color="primary">
              {{menuItem.ctaText}}
            </button>
          </div>

          <ng-template #loadingTemplate>
            <div>
              <h3>Verificando outros serviços</h3>
              <mat-progress-spinner mode="indeterminate" diameter="48" color="primary"></mat-progress-spinner>
            </div>
          </ng-template>
        </li>
      </ul>
    </ng-template>
  </div>
</section>
